import React from 'react';
import styled from 'styled-components';
import { colors } from 'spw-theme';
import {
  SPWTabs,
  SPWTab,
  Row,
  SPWInput,
  Column,
  JustifyStartRow,
  FormBox,
  FormBoxSmall,
} from 'spw-shared/globalComponents';
import {
  DialogContent,
  DialogProps,
  Box,
  Typography,
  MenuItem as MUIMenuItem,
  ListSubheader,
  TextField,
  DialogTitle,
  Dialog,
  FormControlLabel as FormControlLabelMUI,
  Paper,
  RadioGroup,
} from '@mui/material';

export const FormControlLabel = styled(FormControlLabelMUI)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  white-space: nowrap;

  &.MuiFormControlLabel-root {
    margin-right: 0;
    overflow: hidden;

    .MuiTypography-body1 {
      font-size: 14px;
    }
  }
`;

export const FlexBox = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const Key = styled(Typography)`
  && {
    font-size: 12px;
    line-height: 16px;
    color: ${colors.mainGray};
    margin-bottom: 8px;
  }
`;
export const Value = styled(Typography)`
  && {
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 18px;
  }
`;

export const CenteredFlexBox = styled(FlexBox)`
  justify-content: center;
  align-items: center;
  margin-top: 40px;
`;

const inputSizeHalf = 220;

export const DialogTabsContainer = styled.div`
  && {
    padding-left: 24px;
    padding-right: 24px;
    flex: 1;
    overflow-y: auto;
  }
`;

export const RoundDescriptionColumn = styled(Column)`
  flex: 1;
`;

export const UpdateSpaceTabs = styled(SPWTabs)`
  && {
    margin: 0 24px 24px 24px;
    border-bottom: 1px solid #e0e0e0;
  }

  && .MuiTabs-indicator {
    background-color: ${colors.mainBlue};
  }
`;

export const FloorPlanSpaceMessage = styled(FormBoxSmall)`
  && {
    margin-bottom: 16px;
  }
`;

export const NotesFormBox = styled(FormBox)`
  && {
    margin-bottom: 20px;
  }
`;

export const SpaceDialogTab = styled(SPWTab)`
  && {
    min-width: 0;
    padding-left: 0;
    padding-right: 0;
    padding: 0;
    flex-basis: auto;
  }
`;

export const DialogForm = styled.form`
  margin-top: 0;
`;

export const BaseInput = styled(SPWInput)`
  && .MuiInputBase-root {
    border-radius: 0;
  }

  && .MuiInputBase-input {
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    padding: 10px 12px;

    &::placeholder {
      font-style: normal;
      color: ${colors.disabledIcons} !important;
    }

    &:focus::placeholder {
      color: transparent !important;
    }
  }

  && .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.23);
  }
`;

export const SeatCountInput = styled(BaseInput)`
  && {
    width: ${inputSizeHalf}px;
  }
`;

export const HalfFormWidthInput = styled(BaseInput)`
  && {
    width: 160px;
  }
`;
export const RoomNumberInput = styled(BaseInput)`
  && {
    width: ${inputSizeHalf}px;
  }
`;

export const RoomNameInput = styled(BaseInput)`
  && {
    width: ${inputSizeHalf}px;
  }
`;

export const USFInput = styled(BaseInput)`
  && {
    width: 172px;
  }
`;

export const DialogNoteContainer = styled.div`
  li:last-child & {
    border: 0;
  }

  && {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    border-bottom: solid;
    border-width: 0.5px;
    border-color: #c4c4c4;
    cursor: pointer;
  }

  &&.selected {
    border-bottom: none;
  }
`;

export const DialogNoteDate = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: ${colors.midGray};
  width: 75%;
`;

export const DialogNoteBody = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  padding-bottom: 20px;
`;

export const NotesHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const NotesCount = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
`;

export const NoteDialogHeader = styled(Row)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */

  /* Text/Default */

  color: #000000;
`;

export const TIPBold = styled(Row)`
  max-width: 350px;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  /* Text/Hover */

  color: #4a4a4a;
  padding-top: 20px;
`;

export const TipNormal = styled(Row)`
  max-width: 350px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  /* Text/Hover */

  color: #4a4a4a;
  padding-top: 5px;
`;

export const Circle = styled.div`
  width: 15px;
  height: 15px;
  position: relative;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;

  background-color: ${(props) => props.color};
`;

export const NotePositionInput = styled(Row)`
  margin-bottom: 20px;
  margin-top: 10px;
`;

export const ButtonActions = styled.div`
  && {
    display: flex;
    padding: 16px 24px;
  }

  button:not(:first-child) {
    margin-left: 16px;
  }
`;

export const FeedbackDialog = styled((props: DialogProps) => (
  <Dialog {...props} disableScrollLock>
    {props.children}
  </Dialog>
))`
  && .MuiDialog-container {
    align-items: flex-start;
    justify-content: flex-end;
    margin-top: 21px;
  }
`;

export const FeedbackDialogContent = styled(DialogContent)`
  && > * {
    margin: 16px 0;
  }
`;

export const FeedbackDialogActions = styled.div`
  & > button {
    margin-right: 16px;
  }
`;

export const FeedbackDialogSubtitle = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  margin-top: 0px;
`;

export const FeedbackDialogText = styled.div`
  font-size: 16px;
  line-height: 20px;
`;

export const AddDepartmentDialog = styled(Dialog)`
  && .SpwDialogActions {
    padding: 8px 24px 16px;
  }
`;
export const AddDepartmentSubtitle = styled.div`
  font-weight: 500;
  margin: 20px 0;
`;

export const ButtonColumn = styled(Column)`
  && {
    flex: 1;
    justify-content: center;
    align-items: center;
  }
`;

export const AlignEndButtonColumn = styled(ButtonColumn)`
  && {
    align-items: flex-end;
    position: relative;
  }
`;

export const DialogRow = styled(Row)`
  && {
    color: ${colors.mainGray};
    padding-bottom: 20px;
  }
`;

export const MenuItem = styled(MUIMenuItem)`
  && {
    padding-top: 0;
    padding-bottom: 0;

    .showOnHoverOnly {
      opacity: 0;
      transition: opacity 150ms ease;
    }

    &:hover .showOnHoverOnly {
      opacity: 1;
    }
  }
`;

export const CustomSpaceMenuItemContent = styled.div`
  && {
    display: flex;
    flex-direction: row;
  }
`;

export const ListSubheaderCustom = styled(ListSubheader)`
  && {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 14px;
    text-transform: uppercase;
    color: ${colors.black};
  }
`;

export const SpaceCategory = styled(ListSubheader)`
  && {
    display: flex;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    padding: 8px 16px;
    text-transform: uppercase;
    color: ${colors.black};
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px 0px 16px;
    background-color: ${colors.white};
    z-index: 2;
  }
`;

export const BubbleIcon = styled.div`
  && {
    width: 14px;
    height: 14px;
    border-radius: 14px;
    background-color: ${(props) => props.color};
    margin-right: 6px;
  }

  &.larger {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    margin-right: 0;
  }

  &.v-center {
    align-self: center;
  }
`;

export const SpaceName = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  padding: 8px 0;
`;

export const CustomDialogContent = styled(DialogContent)`
  && {
    min-height: 440px;
  }
`;

export const UpdateSpaceDialogContent = styled(CustomDialogContent)`
  && {
    padding: 0px !important;
    min-height: 370px;
    display: flex;
    flex-direction: column;
  }
`;

export const Empty = styled.div`
  && {
    height: 48px;
    width: 100%;
  }
`;

export const SelectOptionSpan = styled.span`
  display: block;
  margin-top: 1px;
`;

export const TextFieldCustom = styled(TextField)`
  && {
    width: 100%;
  }

  && .MuiInputBase-root {
    border-radius: 0;
  }

  && .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.23);
  }
`;

export const ScenarioLegend = styled(Row)`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

export const DateAndEditContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  width: 100%;
`;

export const EditButtonsContainer = styled.div`
  display: flex;
  width: 25%;
  justify-content: space-between;
`;

export const EditButtonCustom = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: ${colors.mainGreen};
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s;

  :hover {
    color: ${colors.secondaryGreen};
    transition: 0.3s;
  }

  &.disabled {
    color: ${colors.mainGray};
  }
`;

export const DeleteButtonCustom = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: ${colors.red};
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s;

  :hover {
    color: ${colors.secondaryRed};
    transition: 0.3s;
  }

  &.disabled {
    color: ${colors.mainGray};
  }
`;

export const AddNoteBox = styled.div`
  margin-left: -8px;
`;

export const NoteButtonActions = styled.div`
  padding-bottom: 20px;

  button:not(:first-child) {
    margin-left: 8px;
  }
`;

export const CharactersRemaining = styled.div`
  font-size: 12px;
  text-align: right;
  padding: 5px 0;
`;

export const USFDialogSubTitle = styled.div`
  font-family: Roboto;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 133% */

  letter-spacing: 0.4px;

  color: ${colors.mainGray};
`;

export const USFDialogValue = styled.div`
  font-family: Roboto;

  font-size: 16px;
  line-height: 28px;
`;

export const USFDialogInfo = styled.div`
  font-family: Roboto;
  font-size: 14px;
  line-height: 20px;
`;

export const SmallDialogButton = styled(Column)`
  && {
    flex: 1;
    height: 36px;
  }
`;

export const SimpleUSFDialogTitle = styled(DialogTitle)`
  && {
    padding: 16px 16px 5px 16px;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;

    &.big-padding {
      padding: 24px 24px;
    }
  }
`;

export const CurrentYearDialogTitle = styled(SimpleUSFDialogTitle)``;

export const CurrentYearInput = styled(SPWInput)`
  && {
    width: 100%;
  }
`;

export const SaveScenarioDialogContent = styled(DialogContent)`
  && {
    padding: 0 24px;
    overflow: auto;
  }
`;

export const ErrorMessage = styled.div`
  && {
    color: ${colors.red};
    margin-bottom: 25px;

    &.text14 {
      font-size: 14px;
      line-height: 20px;
    }

    &.margin20 {
      margin: 3px 0 17px 0;
    }
  }
`;

export const Italic = styled.span`
  && {
    font-style: italic;
    font-family: Roboto;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;

    display: flex;
    align-items: center;

    /* Text/Empty Field */

    color: rgba(0, 0, 0, 0.8);
  }
`;

export const Text14 = styled.div`
  && {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const WorksheetDialogTitle = styled(DialogTitle)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    padding: 16px;
    cursor: move;
  }
`;

export const WorksheetDialogPaper = styled(Paper)`
  && {
    max-width: 371px;
  }
`;

export const WorksheetDialogParagraph = styled.div`
  && {
    &.first {
      margin-bottom: 16px;
    }

    &.middle {
      margin-bottom: 16px;
    }

    &.last {
      margin-bottom: 8px;
    }
  }
`;

export const FixedBackdrop = styled.div`
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: #00000090;
  z-index: 999; // Required to render in front of the scenario calculators but behind the worksheet
`;

export const WorksheetUpdateDialogContent = styled(DialogContent)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;

    ul {
      padding-left: 20px;
      margin-top: 9px;
      margin-bottom: 9px;
    }

    .fc-locker-text-block {
      margin-bottom: 12px;
    }

    &.MuiDialogContent-root:first-child {
      padding: 20px 24px 0 24px;
    }
  }
`;

export const WorksheetUpdateWorkSeatsTable = styled.div`
  border: 1px solid ${colors.veryLightGray};
  border-radius: 4px;
  margin-bottom: 16px;

  p {
    margin: 0px;
  }

  b {
    font-weight: 500;
  }

  div {
    margin: 8px 13px;
  }

  .no-margin-bottom {
    margin-bottom: 0px;
  }
`;

export const WorksheetUpdateDialogRadioGroup = styled(RadioGroup)`
  &&.MuiFormGroup-root {
    justify-content: space-between;
    padding: 5px 0 11px 24px;

    &.last {
      padding-bottom: 9px;
    }
  }
`;

export const WorksheetUpdateDialogFormControlLabel = styled(FormControlLabel)`
  && {
    .MuiTypography-root {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const WorksheetNotesDialogContent = styled(DialogContent)`
  && {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    width: 280px;
  }

  &&.MuiDialogContent-root {
    padding: 8px 16px 16px 16px;
  }
`;

export const WorksheetNoteTextField = styled(TextFieldCustom)`
  && {
    .MuiOutlinedInput-root {
      padding: 8px;
    }

    .MuiInputBase-input {
      min-height: 60px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const WorksheetNotesDot = styled(JustifyStartRow)`
  && {
    &.top {
      margin: 8px 0px;
    }

    margin: 16px 0px 8px 0px;
  }
`;

export const DepartmentName = styled.div`
  && {
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: ${colors.black};
  }
`;

export const SecondaryIdentifierLabel = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.black};
`;

export const ScenarioName = styled.div`
  && {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: ${colors.black};
    margin-bottom: 16px;
  }
`;

export const BigBubbleIcon = styled(BubbleIcon)`
  && {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    margin-right: 8px;
  }
`;

export const CategoriesRow = styled(Column)`
  && {
    margin-bottom: 16px;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const SpaceCategoryTitle = styled(Box)`
  && {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const DialogText = styled.div`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    padding-bottom: 24px;
  }
`;

export const HighlightedText = styled.span`
  && {
    color: #099e88;
    font-weight: bold;
  }
`;

export const HorizontalLine = styled.div`
  && {
    height: 1px;
    border-top: 1px solid #e0e0e0;
  }
`;

export const DefaultColorSubtitle = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    /* identical to box height, or 120% */

    text-align: center;
    letter-spacing: 0.25px;
    text-transform: uppercase;

    /* Text/Hover */

    color: #4a4a4a;
  }
`;

export const ColorBubble = styled('div')<{ color: string }>`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: ${({ color }) => color};
  cursor: pointer;
`;

export const ScenarioNameDialogTitle = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

export const ConfigurationSectionTitles = styled(Box)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const WorksheetUpdateDialogTitle = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 28px;
  }
`;

export const CopyNotesContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`;

export const CopyNotesLabel = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
`;

export const ActionsDialogContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: ${(props: { $width: string }) => props.$width || '392px'};
  box-sizing: border-box;
  padding: 24px;
  height: 248px;
  font-family: Roboto;

  &.smaller {
    height: 218px;
  }

  .actions-row button {
    min-width: 88px;
  }

  .expanded {
    flex: 1;
  }

  .title {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 24px;
  }

  .description {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }

  .margin-right-16 {
    margin-right: 16px;
  }

  .buttons-padding {
    padding-right: 16px;
    padding-left: 16px;
  }
`;

export const AttachmentError = styled.div`
  && {
    display: flex;
    align-items: center;
    color: ${colors.red};
    margin-top: 0px;

    img {
      margin-right: 8px;
    }
  }
`;
